const cn = "5";
typeof window < "u" && ((window.__svelte ??= {}).v ??= /* @__PURE__ */ new Set()).add(cn);
const Ur = 1, Yr = 2, Wr = 4, zr = 8, Gr = 16, dn = 1, _n = 2, hn = 4, vn = 8, pn = 16, Kr = 1, Xr = 2, Jr = 4, gn = 1, mn = 2, ve = "[", $n = "[!", pe = "]", lt = {}, T = Symbol(), Zr = "http://www.w3.org/1999/xhtml", Qr = "http://www.w3.org/2000/svg", ne = !1, P = 2, ge = 4, Ot = 8, Xt = 16, F = 32, tt = 64, bt = 128, I = 256, Et = 512, x = 1024, q = 2048, et = 4096, it = 8192, Rt = 16384, yn = 32768, me = 65536, wn = 1 << 17, bn = 1 << 19, $e = 1 << 20, Ut = 1 << 21, M = Symbol("$state"), ye = Symbol("legacy props"), ts = Symbol("");
var we = Array.isArray, En = Array.prototype.indexOf, xn = Array.from, xt = Object.keys, Tt = Object.defineProperty, X = Object.getOwnPropertyDescriptor, Tn = Object.getOwnPropertyDescriptors, An = Object.prototype, Sn = Array.prototype, be = Object.getPrototypeOf, re = Object.isExtensible;
function es(t) {
  return typeof t == "function";
}
const ns = () => {
};
function rs(t) {
  return t();
}
function Ee(t) {
  for (var e = 0; e < t.length; e++)
    t[e]();
}
const In = typeof requestIdleCallback > "u" ? (t) => setTimeout(t, 1) : requestIdleCallback;
let ft = [], ct = [];
function xe() {
  var t = ft;
  ft = [], Ee(t);
}
function Te() {
  var t = ct;
  ct = [], Ee(t);
}
function kt(t) {
  ft.length === 0 && queueMicrotask(xe), ft.push(t);
}
function ss(t) {
  ct.length === 0 && In(Te), ct.push(t);
}
function se() {
  ft.length > 0 && xe(), ct.length > 0 && Te();
}
function Ae(t) {
  return t === this.v;
}
function Cn(t, e) {
  return t != t ? e == e : t !== e || t !== null && typeof t == "object" || typeof t == "function";
}
function Jt(t) {
  return !Cn(t, this.v);
}
function Nn(t) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function On() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function Rn(t) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function kn() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function Pn() {
  throw new Error("https://svelte.dev/e/hydration_failed");
}
function Ln(t) {
  throw new Error("https://svelte.dev/e/props_invalid_value");
}
function Dn() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function Mn() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function jn() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
let ht = !1, Fn = !1;
function is() {
  ht = !0;
}
function K(t, e) {
  if (typeof t != "object" || t === null || M in t)
    return t;
  const n = be(t);
  if (n !== An && n !== Sn)
    return t;
  var r = /* @__PURE__ */ new Map(), i = we(t), s = H(0), a = h, l = (f) => {
    var o = h;
    L(a);
    var d;
    return d = f(), L(o), d;
  };
  return i && r.set("length", H(
    /** @type {any[]} */
    t.length
  )), new Proxy(
    /** @type {any} */
    t,
    {
      defineProperty(f, o, d) {
        (!("value" in d) || d.configurable === !1 || d.enumerable === !1 || d.writable === !1) && Dn();
        var c = r.get(o);
        return c === void 0 ? (c = l(() => H(d.value)), r.set(o, c)) : N(
          c,
          l(() => K(d.value))
        ), !0;
      },
      deleteProperty(f, o) {
        var d = r.get(o);
        if (d === void 0)
          o in f && r.set(
            o,
            l(() => H(T))
          );
        else {
          if (i && typeof o == "string") {
            var c = (
              /** @type {Source<number>} */
              r.get("length")
            ), u = Number(o);
            Number.isInteger(u) && u < c.v && N(c, u);
          }
          N(d, T), ie(s);
        }
        return !0;
      },
      get(f, o, d) {
        if (o === M)
          return t;
        var c = r.get(o), u = o in f;
        if (c === void 0 && (!u || X(f, o)?.writable) && (c = l(() => H(K(u ? f[o] : T))), r.set(o, c)), c !== void 0) {
          var _ = E(c);
          return _ === T ? void 0 : _;
        }
        return Reflect.get(f, o, d);
      },
      getOwnPropertyDescriptor(f, o) {
        var d = Reflect.getOwnPropertyDescriptor(f, o);
        if (d && "value" in d) {
          var c = r.get(o);
          c && (d.value = E(c));
        } else if (d === void 0) {
          var u = r.get(o), _ = u?.v;
          if (u !== void 0 && _ !== T)
            return {
              enumerable: !0,
              configurable: !0,
              value: _,
              writable: !0
            };
        }
        return d;
      },
      has(f, o) {
        if (o === M)
          return !0;
        var d = r.get(o), c = d !== void 0 && d.v !== T || Reflect.has(f, o);
        if (d !== void 0 || v !== null && (!c || X(f, o)?.writable)) {
          d === void 0 && (d = l(() => H(c ? K(f[o]) : T)), r.set(o, d));
          var u = E(d);
          if (u === T)
            return !1;
        }
        return c;
      },
      set(f, o, d, c) {
        var u = r.get(o), _ = o in f;
        if (i && o === "length")
          for (var $ = d; $ < /** @type {Source<number>} */
          u.v; $ += 1) {
            var y = r.get($ + "");
            y !== void 0 ? N(y, T) : $ in f && (y = l(() => H(T)), r.set($ + "", y));
          }
        u === void 0 ? (!_ || X(f, o)?.writable) && (u = l(() => H(void 0)), N(
          u,
          l(() => K(d))
        ), r.set(o, u)) : (_ = u.v !== T, N(
          u,
          l(() => K(d))
        ));
        var C = Reflect.getOwnPropertyDescriptor(f, o);
        if (C?.set && C.set.call(c, d), !_) {
          if (i && typeof o == "string") {
            var G = (
              /** @type {Source<number>} */
              r.get("length")
            ), R = Number(o);
            Number.isInteger(R) && R >= G.v && N(G, R + 1);
          }
          ie(s);
        }
        return !0;
      },
      ownKeys(f) {
        E(s);
        var o = Reflect.ownKeys(f).filter((u) => {
          var _ = r.get(u);
          return _ === void 0 || _.v !== T;
        });
        for (var [d, c] of r)
          c.v !== T && !(d in f) && o.push(d);
        return o;
      },
      setPrototypeOf() {
        Mn();
      }
    }
  );
}
function ie(t, e = 1) {
  N(t, t.v + e);
}
function ae(t) {
  try {
    if (t !== null && typeof t == "object" && M in t)
      return t[M];
  } catch {
  }
  return t;
}
function as(t, e) {
  return Object.is(ae(t), ae(e));
}
const dt = /* @__PURE__ */ new Map();
function Zt(t, e) {
  var n = {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: t,
    reactions: null,
    equals: Ae,
    rv: 0,
    wv: 0
  };
  return n;
}
function H(t, e) {
  const n = Zt(t);
  return De(n), n;
}
// @__NO_SIDE_EFFECTS__
function Se(t, e = !1) {
  const n = Zt(t);
  return e || (n.equals = Jt), ht && p !== null && p.l !== null && (p.l.s ??= []).push(n), n;
}
function N(t, e, n = !1) {
  h !== null && !k && Mt() && (h.f & (P | Xt)) !== 0 && !j?.includes(t) && jn();
  let r = n ? K(e) : e;
  return qn(t, r);
}
function qn(t, e) {
  if (!t.equals(e)) {
    var n = t.v;
    vt ? dt.set(t, e) : dt.set(t, n), t.v = e, t.wv = je(), Ie(t, q), Mt() && v !== null && (v.f & x) !== 0 && (v.f & (F | tt)) === 0 && (S === null ? zn([t]) : S.push(t));
  }
  return e;
}
function Ie(t, e) {
  var n = t.reactions;
  if (n !== null)
    for (var r = Mt(), i = n.length, s = 0; s < i; s++) {
      var a = n[s], l = a.f;
      (l & q) === 0 && (!r && a === v || (O(a, e), (l & (x | I)) !== 0 && ((l & P) !== 0 ? Ie(
        /** @type {Derived} */
        a,
        et
      ) : Dt(
        /** @type {Effect} */
        a
      ))));
    }
}
// @__NO_SIDE_EFFECTS__
function _t(t) {
  var e = P | q, n = h !== null && (h.f & P) !== 0 ? (
    /** @type {Derived} */
    h
  ) : null;
  return v === null || n !== null && (n.f & I) !== 0 ? e |= I : v.f |= $e, {
    ctx: p,
    deps: null,
    effects: null,
    equals: Ae,
    f: e,
    fn: t,
    reactions: null,
    rv: 0,
    v: (
      /** @type {V} */
      null
    ),
    wv: 0,
    parent: n ?? v
  };
}
function os(t) {
  const e = /* @__PURE__ */ _t(t);
  return De(e), e;
}
// @__NO_SIDE_EFFECTS__
function Hn(t) {
  const e = /* @__PURE__ */ _t(t);
  return e.equals = Jt, e;
}
function Ce(t) {
  var e = t.effects;
  if (e !== null) {
    t.effects = null;
    for (var n = 0; n < e.length; n += 1)
      W(
        /** @type {Effect} */
        e[n]
      );
  }
}
function Bn(t) {
  for (var e = t.parent; e !== null; ) {
    if ((e.f & P) === 0)
      return (
        /** @type {Effect} */
        e
      );
    e = e.parent;
  }
  return null;
}
function Vn(t) {
  var e, n = v;
  Y(Bn(t));
  try {
    Ce(t), e = qe(t);
  } finally {
    Y(n);
  }
  return e;
}
function Ne(t) {
  var e = Vn(t), n = (B || (t.f & I) !== 0) && t.deps !== null ? et : x;
  O(t, n), t.equals(e) || (t.v = e, t.wv = je());
}
function Qt(t) {
  console.warn("https://svelte.dev/e/hydration_mismatch");
}
let b = !1;
function gt(t) {
  b = t;
}
let g;
function U(t) {
  if (t === null)
    throw Qt(), lt;
  return g = t;
}
function Oe() {
  return U(
    /** @type {TemplateNode} */
    /* @__PURE__ */ z(g)
  );
}
function Un(t) {
  if (b) {
    if (/* @__PURE__ */ z(g) !== null)
      throw Qt(), lt;
    g = t;
  }
}
function ls(t = 1) {
  if (b) {
    for (var e = t, n = g; e--; )
      n = /** @type {TemplateNode} */
      /* @__PURE__ */ z(n);
    g = n;
  }
}
function us() {
  for (var t = 0, e = g; ; ) {
    if (e.nodeType === 8) {
      var n = (
        /** @type {Comment} */
        e.data
      );
      if (n === pe) {
        if (t === 0) return e;
        t -= 1;
      } else (n === ve || n === $n) && (t += 1);
    }
    var r = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ z(e)
    );
    e.remove(), e = r;
  }
}
var oe, Re, ke, Pe;
function Yt() {
  if (oe === void 0) {
    oe = window, Re = /Firefox/.test(navigator.userAgent);
    var t = Element.prototype, e = Node.prototype, n = Text.prototype;
    ke = X(e, "firstChild").get, Pe = X(e, "nextSibling").get, re(t) && (t.__click = void 0, t.__className = void 0, t.__attributes = null, t.__style = void 0, t.__e = void 0), re(n) && (n.__t = void 0);
  }
}
function Z(t = "") {
  return document.createTextNode(t);
}
// @__NO_SIDE_EFFECTS__
function Q(t) {
  return ke.call(t);
}
// @__NO_SIDE_EFFECTS__
function z(t) {
  return Pe.call(t);
}
function Yn(t, e) {
  if (!b)
    return /* @__PURE__ */ Q(t);
  var n = (
    /** @type {TemplateNode} */
    /* @__PURE__ */ Q(g)
  );
  if (n === null)
    n = g.appendChild(Z());
  else if (e && n.nodeType !== 3) {
    var r = Z();
    return n?.before(r), U(r), r;
  }
  return U(n), n;
}
function fs(t, e) {
  if (!b) {
    var n = (
      /** @type {DocumentFragment} */
      /* @__PURE__ */ Q(
        /** @type {Node} */
        t
      )
    );
    return n instanceof Comment && n.data === "" ? /* @__PURE__ */ z(n) : n;
  }
  return g;
}
function cs(t, e = 1, n = !1) {
  let r = b ? g : t;
  for (var i; e--; )
    i = r, r = /** @type {TemplateNode} */
    /* @__PURE__ */ z(r);
  if (!b)
    return r;
  var s = r?.nodeType;
  if (n && s !== 3) {
    var a = Z();
    return r === null ? i?.after(a) : r.before(a), U(a), a;
  }
  return U(r), /** @type {TemplateNode} */
  r;
}
function Le(t) {
  t.textContent = "";
}
let yt = !1, At = !1, St = null, J = !1, vt = !1;
function le(t) {
  vt = t;
}
let ut = [];
let h = null, k = !1;
function L(t) {
  h = t;
}
let v = null;
function Y(t) {
  v = t;
}
let j = null;
function Wn(t) {
  j = t;
}
function De(t) {
  h !== null && h.f & Ut && (j === null ? Wn([t]) : j.push(t));
}
let w = null, A = 0, S = null;
function zn(t) {
  S = t;
}
let Me = 1, It = 0, B = !1;
function je() {
  return ++Me;
}
function at(t) {
  var e = t.f;
  if ((e & q) !== 0)
    return !0;
  if ((e & et) !== 0) {
    var n = t.deps, r = (e & I) !== 0;
    if (n !== null) {
      var i, s, a = (e & Et) !== 0, l = r && v !== null && !B, f = n.length;
      if (a || l) {
        var o = (
          /** @type {Derived} */
          t
        ), d = o.parent;
        for (i = 0; i < f; i++)
          s = n[i], (a || !s?.reactions?.includes(o)) && (s.reactions ??= []).push(o);
        a && (o.f ^= Et), l && d !== null && (d.f & I) === 0 && (o.f ^= I);
      }
      for (i = 0; i < f; i++)
        if (s = n[i], at(
          /** @type {Derived} */
          s
        ) && Ne(
          /** @type {Derived} */
          s
        ), s.wv > t.wv)
          return !0;
    }
    (!r || v !== null && !B) && O(t, x);
  }
  return !1;
}
function Gn(t, e) {
  for (var n = e; n !== null; ) {
    if ((n.f & bt) !== 0)
      try {
        n.fn(t);
        return;
      } catch {
        n.f ^= bt;
      }
    n = n.parent;
  }
  throw yt = !1, t;
}
function Kn(t) {
  return (t.f & Rt) === 0 && (t.parent === null || (t.parent.f & bt) === 0);
}
function Pt(t, e, n, r) {
  if (yt) {
    if (n === null && (yt = !1), Kn(e))
      throw t;
    return;
  }
  n !== null && (yt = !0);
  {
    Gn(t, e);
    return;
  }
}
function Fe(t, e, n = !0) {
  var r = t.reactions;
  if (r !== null)
    for (var i = 0; i < r.length; i++) {
      var s = r[i];
      j?.includes(t) || ((s.f & P) !== 0 ? Fe(
        /** @type {Derived} */
        s,
        e,
        !1
      ) : e === s && (n ? O(s, q) : (s.f & x) !== 0 && O(s, et), Dt(
        /** @type {Effect} */
        s
      )));
    }
}
function qe(t) {
  var e = w, n = A, r = S, i = h, s = B, a = j, l = p, f = k, o = t.f;
  w = /** @type {null | Value[]} */
  null, A = 0, S = null, B = (o & I) !== 0 && (k || !J || h === null), h = (o & (F | tt)) === 0 ? t : null, j = null, ue(t.ctx), k = !1, It++, t.f |= Ut;
  try {
    var d = (
      /** @type {Function} */
      (0, t.fn)()
    ), c = t.deps;
    if (w !== null) {
      var u;
      if (Ct(t, A), c !== null && A > 0)
        for (c.length = A + w.length, u = 0; u < w.length; u++)
          c[A + u] = w[u];
      else
        t.deps = c = w;
      if (!B)
        for (u = A; u < c.length; u++)
          (c[u].reactions ??= []).push(t);
    } else c !== null && A < c.length && (Ct(t, A), c.length = A);
    if (Mt() && S !== null && !k && c !== null && (t.f & (P | et | q)) === 0)
      for (u = 0; u < /** @type {Source[]} */
      S.length; u++)
        Fe(
          S[u],
          /** @type {Effect} */
          t
        );
    return i !== null && (It++, S !== null && (r === null ? r = S : r.push(.../** @type {Source[]} */
    S))), d;
  } finally {
    w = e, A = n, S = r, h = i, B = s, j = a, ue(l), k = f, t.f ^= Ut;
  }
}
function Xn(t, e) {
  let n = e.reactions;
  if (n !== null) {
    var r = En.call(n, t);
    if (r !== -1) {
      var i = n.length - 1;
      i === 0 ? n = e.reactions = null : (n[r] = n[i], n.pop());
    }
  }
  n === null && (e.f & P) !== 0 && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (w === null || !w.includes(e)) && (O(e, et), (e.f & (I | Et)) === 0 && (e.f ^= Et), Ce(
    /** @type {Derived} **/
    e
  ), Ct(
    /** @type {Derived} **/
    e,
    0
  ));
}
function Ct(t, e) {
  var n = t.deps;
  if (n !== null)
    for (var r = e; r < n.length; r++)
      Xn(t, n[r]);
}
function Lt(t) {
  var e = t.f;
  if ((e & Rt) === 0) {
    O(t, x);
    var n = v, r = p, i = J;
    v = t, J = !0;
    try {
      (e & Xt) !== 0 ? lr(t) : We(t), Ye(t);
      var s = qe(t);
      t.teardown = typeof s == "function" ? s : null, t.wv = Me;
      var a = t.deps, l;
      ne && Fn && t.f & q;
    } catch (f) {
      Pt(f, t, n, r || t.ctx);
    } finally {
      J = i, v = n;
    }
  }
}
function Jn() {
  try {
    kn();
  } catch (t) {
    if (St !== null)
      Pt(t, St, null);
    else
      throw t;
  }
}
function He() {
  var t = J;
  try {
    var e = 0;
    for (J = !0; ut.length > 0; ) {
      e++ > 1e3 && Jn();
      var n = ut, r = n.length;
      ut = [];
      for (var i = 0; i < r; i++) {
        var s = Qn(n[i]);
        Zn(s);
      }
    }
  } finally {
    At = !1, J = t, St = null, dt.clear();
  }
}
function Zn(t) {
  var e = t.length;
  if (e !== 0)
    for (var n = 0; n < e; n++) {
      var r = t[n];
      if ((r.f & (Rt | it)) === 0)
        try {
          at(r) && (Lt(r), r.deps === null && r.first === null && r.nodes_start === null && (r.teardown === null ? ze(r) : r.fn = null));
        } catch (i) {
          Pt(i, r, null, r.ctx);
        }
    }
}
function Dt(t) {
  At || (At = !0, queueMicrotask(He));
  for (var e = St = t; e.parent !== null; ) {
    e = e.parent;
    var n = e.f;
    if ((n & (tt | F)) !== 0) {
      if ((n & x) === 0) return;
      e.f ^= x;
    }
  }
  ut.push(e);
}
function Qn(t) {
  for (var e = [], n = t; n !== null; ) {
    var r = n.f, i = (r & (F | tt)) !== 0, s = i && (r & x) !== 0;
    if (!s && (r & it) === 0) {
      if ((r & ge) !== 0)
        e.push(n);
      else if (i)
        n.f ^= x;
      else {
        var a = h;
        try {
          h = n, at(n) && Lt(n);
        } catch (o) {
          Pt(o, n, null, n.ctx);
        } finally {
          h = a;
        }
      }
      var l = n.first;
      if (l !== null) {
        n = l;
        continue;
      }
    }
    var f = n.parent;
    for (n = n.next; n === null && f !== null; )
      n = f.next, f = f.parent;
  }
  return e;
}
function Be(t) {
  var e;
  for (se(); ut.length > 0; )
    At = !0, He(), se();
  return (
    /** @type {T} */
    e
  );
}
function E(t) {
  var e = t.f, n = (e & P) !== 0;
  if (h !== null && !k) {
    if (!j?.includes(t)) {
      var r = h.deps;
      t.rv < It && (t.rv = It, w === null && r !== null && r[A] === t ? A++ : w === null ? w = [t] : (!B || !w.includes(t)) && w.push(t));
    }
  } else if (n && /** @type {Derived} */
  t.deps === null && /** @type {Derived} */
  t.effects === null) {
    var i = (
      /** @type {Derived} */
      t
    ), s = i.parent;
    s !== null && (s.f & I) === 0 && (i.f ^= I);
  }
  return n && (i = /** @type {Derived} */
  t, at(i) && Ne(i)), vt && dt.has(t) ? dt.get(t) : t.v;
}
function Nt(t) {
  var e = k;
  try {
    return k = !0, t();
  } finally {
    k = e;
  }
}
const tr = -7169;
function O(t, e) {
  t.f = t.f & tr | e;
}
function ds(t) {
  if (!(typeof t != "object" || !t || t instanceof EventTarget)) {
    if (M in t)
      Wt(t);
    else if (!Array.isArray(t))
      for (let e in t) {
        const n = t[e];
        typeof n == "object" && n && M in n && Wt(n);
      }
  }
}
function Wt(t, e = /* @__PURE__ */ new Set()) {
  if (typeof t == "object" && t !== null && // We don't want to traverse DOM elements
  !(t instanceof EventTarget) && !e.has(t)) {
    e.add(t), t instanceof Date && t.getTime();
    for (let r in t)
      try {
        Wt(t[r], e);
      } catch {
      }
    const n = be(t);
    if (n !== Object.prototype && n !== Array.prototype && n !== Map.prototype && n !== Set.prototype && n !== Date.prototype) {
      const r = Tn(n);
      for (let i in r) {
        const s = r[i].get;
        if (s)
          try {
            s.call(t);
          } catch {
          }
      }
    }
  }
}
function Ve(t) {
  v === null && h === null && Rn(), h !== null && (h.f & I) !== 0 && v === null && On(), vt && Nn();
}
function er(t, e) {
  var n = e.last;
  n === null ? e.last = e.first = t : (n.next = t, t.prev = n, e.last = t);
}
function nt(t, e, n, r = !0) {
  var i = v, s = {
    ctx: p,
    deps: null,
    nodes_start: null,
    nodes_end: null,
    f: t | q,
    first: null,
    fn: e,
    last: null,
    next: null,
    parent: i,
    prev: null,
    teardown: null,
    transitions: null,
    wv: 0
  };
  if (n)
    try {
      Lt(s), s.f |= yn;
    } catch (f) {
      throw W(s), f;
    }
  else e !== null && Dt(s);
  var a = n && s.deps === null && s.first === null && s.nodes_start === null && s.teardown === null && (s.f & ($e | bt)) === 0;
  if (!a && r && (i !== null && er(s, i), h !== null && (h.f & P) !== 0)) {
    var l = (
      /** @type {Derived} */
      h
    );
    (l.effects ??= []).push(s);
  }
  return s;
}
function Ue(t) {
  const e = nt(Ot, null, !1);
  return O(e, x), e.teardown = t, e;
}
function nr(t) {
  Ve();
  var e = v !== null && (v.f & F) !== 0 && p !== null && !p.m;
  if (e) {
    var n = (
      /** @type {ComponentContext} */
      p
    );
    (n.e ??= []).push({
      fn: t,
      effect: v,
      reaction: h
    });
  } else {
    var r = te(t);
    return r;
  }
}
function _s(t) {
  return Ve(), pt(t);
}
function rr(t) {
  const e = nt(tt, t, !0);
  return () => {
    W(e);
  };
}
function sr(t) {
  const e = nt(tt, t, !0);
  return (n = {}) => new Promise((r) => {
    n.outro ? ur(e, () => {
      W(e), r(void 0);
    }) : (W(e), r(void 0));
  });
}
function te(t) {
  return nt(ge, t, !1);
}
function hs(t, e) {
  var n = (
    /** @type {ComponentContextLegacy} */
    p
  ), r = { effect: null, ran: !1 };
  n.l.r1.push(r), r.effect = pt(() => {
    t(), !r.ran && (r.ran = !0, N(n.l.r2, !0), Nt(e));
  });
}
function vs() {
  var t = (
    /** @type {ComponentContextLegacy} */
    p
  );
  pt(() => {
    if (E(t.l.r2)) {
      for (var e of t.l.r1) {
        var n = e.effect;
        (n.f & x) !== 0 && O(n, et), at(n) && Lt(n), e.ran = !1;
      }
      t.l.r2.v = !1;
    }
  });
}
function pt(t) {
  return nt(Ot, t, !0);
}
function ir(t, e = [], n = _t) {
  const r = e.map(n);
  return ar(() => t(...r.map(E)));
}
function ar(t, e = 0) {
  return nt(Ot | Xt | e, t, !0);
}
function or(t, e = !0) {
  return nt(Ot | F, t, !0, e);
}
function Ye(t) {
  var e = t.teardown;
  if (e !== null) {
    const n = vt, r = h;
    le(!0), L(null);
    try {
      e.call(null);
    } finally {
      le(n), L(r);
    }
  }
}
function We(t, e = !1) {
  var n = t.first;
  for (t.first = t.last = null; n !== null; ) {
    var r = n.next;
    (n.f & tt) !== 0 ? n.parent = null : W(n, e), n = r;
  }
}
function lr(t) {
  for (var e = t.first; e !== null; ) {
    var n = e.next;
    (e.f & F) === 0 && W(e), e = n;
  }
}
function W(t, e = !0) {
  var n = !1;
  if ((e || (t.f & bn) !== 0) && t.nodes_start !== null) {
    for (var r = t.nodes_start, i = t.nodes_end; r !== null; ) {
      var s = r === i ? null : (
        /** @type {TemplateNode} */
        /* @__PURE__ */ z(r)
      );
      r.remove(), r = s;
    }
    n = !0;
  }
  We(t, e && !n), Ct(t, 0), O(t, Rt);
  var a = t.transitions;
  if (a !== null)
    for (const f of a)
      f.stop();
  Ye(t);
  var l = t.parent;
  l !== null && l.first !== null && ze(t), t.next = t.prev = t.teardown = t.ctx = t.deps = t.fn = t.nodes_start = t.nodes_end = null;
}
function ze(t) {
  var e = t.parent, n = t.prev, r = t.next;
  n !== null && (n.next = r), r !== null && (r.prev = n), e !== null && (e.first === t && (e.first = r), e.last === t && (e.last = n));
}
function ur(t, e) {
  var n = [];
  Ge(t, n, !0), fr(n, () => {
    W(t), e && e();
  });
}
function fr(t, e) {
  var n = t.length;
  if (n > 0) {
    var r = () => --n || e();
    for (var i of t)
      i.out(r);
  } else
    e();
}
function Ge(t, e, n) {
  if ((t.f & it) === 0) {
    if (t.f ^= it, t.transitions !== null)
      for (const a of t.transitions)
        (a.is_global || n) && e.push(a);
    for (var r = t.first; r !== null; ) {
      var i = r.next, s = (r.f & me) !== 0 || (r.f & F) !== 0;
      Ge(r, e, s ? n : !1), r = i;
    }
  }
}
function ps(t) {
  Ke(t, !0);
}
function Ke(t, e) {
  if ((t.f & it) !== 0) {
    t.f ^= it, (t.f & x) === 0 && (t.f ^= x), at(t) && (O(t, q), Dt(t));
    for (var n = t.first; n !== null; ) {
      var r = n.next, i = (n.f & me) !== 0 || (n.f & F) !== 0;
      Ke(n, i ? e : !1), n = r;
    }
    if (t.transitions !== null)
      for (const s of t.transitions)
        (s.is_global || e) && s.in();
  }
}
function cr(t) {
  throw new Error("https://svelte.dev/e/lifecycle_outside_component");
}
let p = null;
function ue(t) {
  p = t;
}
function gs(t) {
  return (
    /** @type {T} */
    Ze().get(t)
  );
}
function ms(t, e) {
  return Ze().set(t, e), e;
}
function Xe(t, e = !1, n) {
  var r = p = {
    p,
    c: null,
    d: !1,
    e: null,
    m: !1,
    s: t,
    x: null,
    l: null
  };
  ht && !e && (p.l = {
    s: null,
    u: null,
    r1: [],
    r2: Zt(!1)
  }), Ue(() => {
    r.d = !0;
  });
}
function Je(t) {
  const e = p;
  if (e !== null) {
    t !== void 0 && (e.x = t);
    const a = e.e;
    if (a !== null) {
      var n = v, r = h;
      e.e = null;
      try {
        for (var i = 0; i < a.length; i++) {
          var s = a[i];
          Y(s.effect), L(s.reaction), te(s.fn);
        }
      } finally {
        Y(n), L(r);
      }
    }
    p = e.p, e.m = !0;
  }
  return t || /** @type {T} */
  {};
}
function Mt() {
  return !ht || p !== null && p.l === null;
}
function Ze(t) {
  return p === null && cr(), p.c ??= new Map(dr(p) || void 0);
}
function dr(t) {
  let e = t.p;
  for (; e !== null; ) {
    const n = e.c;
    if (n !== null)
      return n;
    e = e.p;
  }
  return null;
}
function $s(t) {
  return t.endsWith("capture") && t !== "gotpointercapture" && t !== "lostpointercapture";
}
const _r = [
  "beforeinput",
  "click",
  "change",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
];
function ys(t) {
  return _r.includes(t);
}
const hr = {
  // no `class: 'className'` because we handle that separately
  formnovalidate: "formNoValidate",
  ismap: "isMap",
  nomodule: "noModule",
  playsinline: "playsInline",
  readonly: "readOnly",
  defaultvalue: "defaultValue",
  defaultchecked: "defaultChecked",
  srcobject: "srcObject",
  novalidate: "noValidate",
  allowfullscreen: "allowFullscreen",
  disablepictureinpicture: "disablePictureInPicture",
  disableremoteplayback: "disableRemotePlayback"
};
function ws(t) {
  return t = t.toLowerCase(), hr[t] ?? t;
}
const vr = ["touchstart", "touchmove"];
function pr(t) {
  return vr.includes(t);
}
const gr = (
  /** @type {const} */
  ["textarea", "script", "style", "title"]
);
function bs(t) {
  return gr.includes(
    /** @type {RAW_TEXT_ELEMENTS[number]} */
    t
  );
}
function Es(t, e) {
  if (e) {
    const n = document.body;
    t.autofocus = !0, kt(() => {
      document.activeElement === n && t.focus();
    });
  }
}
function xs(t) {
  b && /* @__PURE__ */ Q(t) !== null && Le(t);
}
let fe = !1;
function mr() {
  fe || (fe = !0, document.addEventListener(
    "reset",
    (t) => {
      Promise.resolve().then(() => {
        if (!t.defaultPrevented)
          for (
            const e of
            /**@type {HTMLFormElement} */
            t.target.elements
          )
            e.__on_r?.();
      });
    },
    // In the capture phase to guarantee we get noticed of it (no possiblity of stopPropagation)
    { capture: !0 }
  ));
}
function Qe(t) {
  var e = h, n = v;
  L(null), Y(null);
  try {
    return t();
  } finally {
    L(e), Y(n);
  }
}
function Ts(t, e, n, r = n) {
  t.addEventListener(e, () => Qe(n));
  const i = t.__on_r;
  i ? t.__on_r = () => {
    i(), r(!0);
  } : t.__on_r = () => r(!0), mr();
}
const tn = /* @__PURE__ */ new Set(), zt = /* @__PURE__ */ new Set();
function $r(t, e, n, r = {}) {
  function i(s) {
    if (r.capture || ot.call(e, s), !s.cancelBubble)
      return Qe(() => n?.call(this, s));
  }
  return t.startsWith("pointer") || t.startsWith("touch") || t === "wheel" ? kt(() => {
    e.addEventListener(t, i, r);
  }) : e.addEventListener(t, i, r), i;
}
function As(t, e, n, r, i) {
  var s = { capture: r, passive: i }, a = $r(t, e, n, s);
  (e === document.body || e === window || e === document) && Ue(() => {
    e.removeEventListener(t, a, s);
  });
}
function Ss(t) {
  for (var e = 0; e < t.length; e++)
    tn.add(t[e]);
  for (var n of zt)
    n(t);
}
function ot(t) {
  var e = this, n = (
    /** @type {Node} */
    e.ownerDocument
  ), r = t.type, i = t.composedPath?.() || [], s = (
    /** @type {null | Element} */
    i[0] || t.target
  ), a = 0, l = t.__root;
  if (l) {
    var f = i.indexOf(l);
    if (f !== -1 && (e === document || e === /** @type {any} */
    window)) {
      t.__root = e;
      return;
    }
    var o = i.indexOf(e);
    if (o === -1)
      return;
    f <= o && (a = f);
  }
  if (s = /** @type {Element} */
  i[a] || t.target, s !== e) {
    Tt(t, "currentTarget", {
      configurable: !0,
      get() {
        return s || n;
      }
    });
    var d = h, c = v;
    L(null), Y(null);
    try {
      for (var u, _ = []; s !== null; ) {
        var $ = s.assignedSlot || s.parentNode || /** @type {any} */
        s.host || null;
        try {
          var y = s["__" + r];
          if (y != null && (!/** @type {any} */
          s.disabled || // DOM could've been updated already by the time this is reached, so we check this as well
          // -> the target could not have been disabled because it emits the event in the first place
          t.target === s))
            if (we(y)) {
              var [C, ...G] = y;
              C.apply(s, [t, ...G]);
            } else
              y.call(s, t);
        } catch (R) {
          u ? _.push(R) : u = R;
        }
        if (t.cancelBubble || $ === e || $ === null)
          break;
        s = $;
      }
      if (u) {
        for (let R of _)
          queueMicrotask(() => {
            throw R;
          });
        throw u;
      }
    } finally {
      t.__root = e, delete t.currentTarget, L(d), Y(c);
    }
  }
}
function yr(t) {
  var e = document.createElement("template");
  return e.innerHTML = t, e.content;
}
function V(t, e) {
  var n = (
    /** @type {Effect} */
    v
  );
  n.nodes_start === null && (n.nodes_start = t, n.nodes_end = e);
}
// @__NO_SIDE_EFFECTS__
function wr(t, e) {
  var n = (e & gn) !== 0, r = (e & mn) !== 0, i, s = !t.startsWith("<!>");
  return () => {
    if (b)
      return V(g, null), g;
    i === void 0 && (i = yr(s ? t : "<!>" + t), n || (i = /** @type {Node} */
    /* @__PURE__ */ Q(i)));
    var a = (
      /** @type {TemplateNode} */
      r || Re ? document.importNode(i, !0) : i.cloneNode(!0)
    );
    if (n) {
      var l = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Q(a)
      ), f = (
        /** @type {TemplateNode} */
        a.lastChild
      );
      V(l, f);
    } else
      V(a, a);
    return a;
  };
}
function Is(t = "") {
  if (!b) {
    var e = Z(t + "");
    return V(e, e), e;
  }
  var n = g;
  return n.nodeType !== 3 && (n.before(n = Z()), U(n)), V(n, n), n;
}
function Cs() {
  if (b)
    return V(g, null), g;
  var t = document.createDocumentFragment(), e = document.createComment(""), n = Z();
  return t.append(e, n), V(e, n), t;
}
function en(t, e) {
  if (b) {
    v.nodes_end = g, Oe();
    return;
  }
  t !== null && t.before(
    /** @type {Node} */
    e
  );
}
let Gt = !0;
function Ns(t) {
  Gt = t;
}
function br(t, e) {
  var n = e == null ? "" : typeof e == "object" ? e + "" : e;
  n !== (t.__t ??= t.nodeValue) && (t.__t = n, t.nodeValue = n + "");
}
function ee(t, e) {
  return nn(t, e);
}
function Er(t, e) {
  Yt(), e.intro = e.intro ?? !1;
  const n = e.target, r = b, i = g;
  try {
    for (var s = (
      /** @type {TemplateNode} */
      /* @__PURE__ */ Q(n)
    ); s && (s.nodeType !== 8 || /** @type {Comment} */
    s.data !== ve); )
      s = /** @type {TemplateNode} */
      /* @__PURE__ */ z(s);
    if (!s)
      throw lt;
    gt(!0), U(
      /** @type {Comment} */
      s
    ), Oe();
    const a = nn(t, { ...e, anchor: s });
    if (g === null || g.nodeType !== 8 || /** @type {Comment} */
    g.data !== pe)
      throw Qt(), lt;
    return gt(!1), /**  @type {Exports} */
    a;
  } catch (a) {
    if (a === lt)
      return e.recover === !1 && Pn(), Yt(), Le(n), gt(!1), ee(t, e);
    throw a;
  } finally {
    gt(r), U(i);
  }
}
const st = /* @__PURE__ */ new Map();
function nn(t, { target: e, anchor: n, props: r = {}, events: i, context: s, intro: a = !0 }) {
  Yt();
  var l = /* @__PURE__ */ new Set(), f = (c) => {
    for (var u = 0; u < c.length; u++) {
      var _ = c[u];
      if (!l.has(_)) {
        l.add(_);
        var $ = pr(_);
        e.addEventListener(_, ot, { passive: $ });
        var y = st.get(_);
        y === void 0 ? (document.addEventListener(_, ot, { passive: $ }), st.set(_, 1)) : st.set(_, y + 1);
      }
    }
  };
  f(xn(tn)), zt.add(f);
  var o = void 0, d = sr(() => {
    var c = n ?? e.appendChild(Z());
    return or(() => {
      if (s) {
        Xe({});
        var u = (
          /** @type {ComponentContext} */
          p
        );
        u.c = s;
      }
      i && (r.$$events = i), b && V(
        /** @type {TemplateNode} */
        c,
        null
      ), Gt = a, o = t(c, r) || {}, Gt = !0, b && (v.nodes_end = g), s && Je();
    }), () => {
      for (var u of l) {
        e.removeEventListener(u, ot);
        var _ = (
          /** @type {number} */
          st.get(u)
        );
        --_ === 0 ? (document.removeEventListener(u, ot), st.delete(u)) : st.set(u, _);
      }
      zt.delete(f), c !== n && c.parentNode?.removeChild(c);
    };
  });
  return Kt.set(o, d), o;
}
let Kt = /* @__PURE__ */ new WeakMap();
function rn(t, e) {
  const n = Kt.get(t);
  return n ? (Kt.delete(t), n(e)) : Promise.resolve();
}
function xr(t, e) {
  kt(() => {
    var n = t.getRootNode(), r = (
      /** @type {ShadowRoot} */
      n.host ? (
        /** @type {ShadowRoot} */
        n
      ) : (
        /** @type {Document} */
        n.head ?? /** @type {Document} */
        n.ownerDocument.head
      )
    );
    if (!r.querySelector("#" + e.hash)) {
      const i = document.createElement("style");
      i.id = e.hash, i.textContent = e.code, r.appendChild(i);
    }
  });
}
function ce(t, e) {
  return t === e || t?.[M] === e;
}
function Tr(t = {}, e, n, r) {
  return te(() => {
    var i, s;
    return pt(() => {
      i = s, s = [], Nt(() => {
        t !== n(...s) && (e(t, ...s), i && ce(n(...i), t) && e(null, ...i));
      });
    }), () => {
      kt(() => {
        s && ce(n(...s), t) && e(null, ...s);
      });
    };
  }), t;
}
let mt = !1;
function Ar(t) {
  var e = mt;
  try {
    return mt = !1, [t(), mt];
  } finally {
    mt = e;
  }
}
function de(t) {
  return t.ctx?.d ?? !1;
}
function Sr(t, e, n, r) {
  var i = (n & dn) !== 0, s = !ht || (n & _n) !== 0, a = (n & vn) !== 0, l = (n & pn) !== 0, f = !1, o;
  a ? [o, f] = Ar(() => (
    /** @type {V} */
    t[e]
  )) : o = /** @type {V} */
  t[e];
  var d = M in t || ye in t, c = a && (X(t, e)?.set ?? (d && e in t && ((m) => t[e] = m))) || void 0, u = (
    /** @type {V} */
    r
  ), _ = !0, $ = !1, y = () => ($ = !0, _ && (_ = !1, l ? u = Nt(
    /** @type {() => V} */
    r
  ) : u = /** @type {V} */
  r), u);
  o === void 0 && r !== void 0 && (c && s && Ln(), o = y(), c && c(o));
  var C;
  if (s)
    C = () => {
      var m = (
        /** @type {V} */
        t[e]
      );
      return m === void 0 ? y() : (_ = !0, $ = !1, m);
    };
  else {
    var G = (i ? _t : Hn)(
      () => (
        /** @type {V} */
        t[e]
      )
    );
    G.f |= wn, C = () => {
      var m = E(G);
      return m !== void 0 && (u = /** @type {V} */
      void 0), m === void 0 ? u : m;
    };
  }
  if ((n & hn) === 0)
    return C;
  if (c) {
    var R = t.$$legacy;
    return function(m, rt) {
      return arguments.length > 0 ? ((!s || !rt || R || f) && c(rt ? C() : m), m) : C();
    };
  }
  var Ft = !1, qt = /* @__PURE__ */ Se(o), D = /* @__PURE__ */ _t(() => {
    var m = C(), rt = E(qt);
    return Ft ? (Ft = !1, rt) : qt.v = m;
  });
  return a && E(D), i || (D.equals = Jt), function(m, rt) {
    if (arguments.length > 0) {
      const Ht = rt ? E(D) : s && a ? K(m) : m;
      if (!D.equals(Ht)) {
        if (Ft = !0, N(qt, Ht), $ && u !== void 0 && (u = Ht), de(D))
          return m;
        Nt(() => E(D));
      }
      return m;
    }
    return de(D) ? D.v : E(D);
  };
}
function Ir(t) {
  return new Cr(t);
}
class Cr {
  /** @type {any} */
  #e;
  /** @type {Record<string, any>} */
  #t;
  /**
   * @param {ComponentConstructorOptions & {
   *  component: any;
   * }} options
   */
  constructor(e) {
    var n = /* @__PURE__ */ new Map(), r = (s, a) => {
      var l = /* @__PURE__ */ Se(a);
      return n.set(s, l), l;
    };
    const i = new Proxy(
      { ...e.props || {}, $$events: {} },
      {
        get(s, a) {
          return E(n.get(a) ?? r(a, Reflect.get(s, a)));
        },
        has(s, a) {
          return a === ye ? !0 : (E(n.get(a) ?? r(a, Reflect.get(s, a))), Reflect.has(s, a));
        },
        set(s, a, l) {
          return N(n.get(a) ?? r(a, l), l), Reflect.set(s, a, l);
        }
      }
    );
    this.#t = (e.hydrate ? Er : ee)(e.component, {
      target: e.target,
      anchor: e.anchor,
      props: i,
      context: e.context,
      intro: e.intro ?? !1,
      recover: e.recover
    }), (!e?.props?.$$host || e.sync === !1) && Be(), this.#e = i.$$events;
    for (const s of Object.keys(this.#t))
      s === "$set" || s === "$destroy" || s === "$on" || Tt(this, s, {
        get() {
          return this.#t[s];
        },
        /** @param {any} value */
        set(a) {
          this.#t[s] = a;
        },
        enumerable: !0
      });
    this.#t.$set = /** @param {Record<string, any>} next */
    (s) => {
      Object.assign(i, s);
    }, this.#t.$destroy = () => {
      rn(this.#t);
    };
  }
  /** @param {Record<string, any>} props */
  $set(e) {
    this.#t.$set(e);
  }
  /**
   * @param {string} event
   * @param {(...args: any[]) => any} callback
   * @returns {any}
   */
  $on(e, n) {
    this.#e[e] = this.#e[e] || [];
    const r = (...i) => n.call(this, ...i);
    return this.#e[e].push(r), () => {
      this.#e[e] = this.#e[e].filter(
        /** @param {any} fn */
        (i) => i !== r
      );
    };
  }
  $destroy() {
    this.#t.$destroy();
  }
}
let sn;
typeof HTMLElement == "function" && (sn = class extends HTMLElement {
  /** The Svelte component constructor */
  $$ctor;
  /** Slots */
  $$s;
  /** @type {any} The Svelte component instance */
  $$c;
  /** Whether or not the custom element is connected */
  $$cn = !1;
  /** @type {Record<string, any>} Component props data */
  $$d = {};
  /** `true` if currently in the process of reflecting component props back to attributes */
  $$r = !1;
  /** @type {Record<string, CustomElementPropDefinition>} Props definition (name, reflected, type etc) */
  $$p_d = {};
  /** @type {Record<string, EventListenerOrEventListenerObject[]>} Event listeners */
  $$l = {};
  /** @type {Map<EventListenerOrEventListenerObject, Function>} Event listener unsubscribe functions */
  $$l_u = /* @__PURE__ */ new Map();
  /** @type {any} The managed render effect for reflecting attributes */
  $$me;
  /**
   * @param {*} $$componentCtor
   * @param {*} $$slots
   * @param {*} use_shadow_dom
   */
  constructor(t, e, n) {
    super(), this.$$ctor = t, this.$$s = e, n && this.attachShadow({ mode: "open" });
  }
  /**
   * @param {string} type
   * @param {EventListenerOrEventListenerObject} listener
   * @param {boolean | AddEventListenerOptions} [options]
   */
  addEventListener(t, e, n) {
    if (this.$$l[t] = this.$$l[t] || [], this.$$l[t].push(e), this.$$c) {
      const r = this.$$c.$on(t, e);
      this.$$l_u.set(e, r);
    }
    super.addEventListener(t, e, n);
  }
  /**
   * @param {string} type
   * @param {EventListenerOrEventListenerObject} listener
   * @param {boolean | AddEventListenerOptions} [options]
   */
  removeEventListener(t, e, n) {
    if (super.removeEventListener(t, e, n), this.$$c) {
      const r = this.$$l_u.get(e);
      r && (r(), this.$$l_u.delete(e));
    }
  }
  async connectedCallback() {
    if (this.$$cn = !0, !this.$$c) {
      let t = function(r) {
        return (i) => {
          const s = document.createElement("slot");
          r !== "default" && (s.name = r), en(i, s);
        };
      };
      if (await Promise.resolve(), !this.$$cn || this.$$c)
        return;
      const e = {}, n = Nr(this);
      for (const r of this.$$s)
        r in n && (r === "default" && !this.$$d.children ? (this.$$d.children = t(r), e.default = !0) : e[r] = t(r));
      for (const r of this.attributes) {
        const i = this.$$g_p(r.name);
        i in this.$$d || (this.$$d[i] = wt(i, r.value, this.$$p_d, "toProp"));
      }
      for (const r in this.$$p_d)
        !(r in this.$$d) && this[r] !== void 0 && (this.$$d[r] = this[r], delete this[r]);
      this.$$c = Ir({
        component: this.$$ctor,
        target: this.shadowRoot || this,
        props: {
          ...this.$$d,
          $$slots: e,
          $$host: this
        }
      }), this.$$me = rr(() => {
        pt(() => {
          this.$$r = !0;
          for (const r of xt(this.$$c)) {
            if (!this.$$p_d[r]?.reflect) continue;
            this.$$d[r] = this.$$c[r];
            const i = wt(
              r,
              this.$$d[r],
              this.$$p_d,
              "toAttribute"
            );
            i == null ? this.removeAttribute(this.$$p_d[r].attribute || r) : this.setAttribute(this.$$p_d[r].attribute || r, i);
          }
          this.$$r = !1;
        });
      });
      for (const r in this.$$l)
        for (const i of this.$$l[r]) {
          const s = this.$$c.$on(r, i);
          this.$$l_u.set(i, s);
        }
      this.$$l = {};
    }
  }
  // We don't need this when working within Svelte code, but for compatibility of people using this outside of Svelte
  // and setting attributes through setAttribute etc, this is helpful
  /**
   * @param {string} attr
   * @param {string} _oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(t, e, n) {
    this.$$r || (t = this.$$g_p(t), this.$$d[t] = wt(t, n, this.$$p_d, "toProp"), this.$$c?.$set({ [t]: this.$$d[t] }));
  }
  disconnectedCallback() {
    this.$$cn = !1, Promise.resolve().then(() => {
      !this.$$cn && this.$$c && (this.$$c.$destroy(), this.$$me(), this.$$c = void 0);
    });
  }
  /**
   * @param {string} attribute_name
   */
  $$g_p(t) {
    return xt(this.$$p_d).find(
      (e) => this.$$p_d[e].attribute === t || !this.$$p_d[e].attribute && e.toLowerCase() === t
    ) || t;
  }
});
function wt(t, e, n, r) {
  const i = n[t]?.type;
  if (e = i === "Boolean" && typeof e != "boolean" ? e != null : e, !r || !n[t])
    return e;
  if (r === "toAttribute")
    switch (i) {
      case "Object":
      case "Array":
        return e == null ? null : JSON.stringify(e);
      case "Boolean":
        return e ? "" : null;
      case "Number":
        return e ?? null;
      default:
        return e;
    }
  else
    switch (i) {
      case "Object":
      case "Array":
        return e && JSON.parse(e);
      case "Boolean":
        return e;
      // conversion already handled above
      case "Number":
        return e != null ? +e : e;
      default:
        return e;
    }
}
function Nr(t) {
  const e = {};
  return t.childNodes.forEach((n) => {
    e[
      /** @type {Element} node */
      n.slot || "default"
    ] = !0;
  }), e;
}
function Or(t, e, n, r, i, s) {
  let a = class extends sn {
    constructor() {
      super(t, n, i), this.$$p_d = e;
    }
    static get observedAttributes() {
      return xt(e).map(
        (l) => (e[l].attribute || l).toLowerCase()
      );
    }
  };
  return xt(e).forEach((l) => {
    Tt(a.prototype, l, {
      get() {
        return this.$$c && l in this.$$c ? this.$$c[l] : this.$$d[l];
      },
      set(f) {
        f = wt(l, f, e), this.$$d[l] = f;
        var o = this.$$c;
        if (o) {
          var d = X(o, l)?.get;
          d ? o[l] = f : o.$set({ [l]: f });
        }
      }
    });
  }), r.forEach((l) => {
    Tt(a.prototype, l, {
      get() {
        return this.$$c?.[l];
      }
    });
  }), s && (a = s(a)), t.element = /** @type {any} */
  a, a;
}
const $t = 10, Os = [
  "article",
  "aside",
  "details",
  "dialog",
  "figure",
  "figcaption",
  "footer",
  "header",
  "hgroup",
  "main",
  "nav",
  "section"
  // Not added because it is rarely used, but may be a candidate to add in the future
  // "abbr",
  // "address",
  // "bdi",
  // "bdo",
  // "cite",
  // "data",
  // "kbd",
  // "map", // and "area"
  // "mark",
  // "meter",
  // "q",
  // "samp",
  // "search",
  // "slot",
], Rs = [
  "span",
  "ruby",
  "rt",
  "rp"
  // Not added because it is rarely used, but may be a candidate to add in the future
  // "time",
  // "var",
];
var Rr = /* @__PURE__ */ wr('<div id="mt-rich-text-editor-tooltip" class="mt-rich-text-editor-tooltip svelte-jbfzcg"> </div>');
const kr = {
  hash: "svelte-jbfzcg",
  code: "div.svelte-jbfzcg {position:absolute;top:110%;left:50%;transform:translateX(-50%);color:white;background:black;padding:4px;border-radius:5px;width:max-content;white-space:nowrap;font-size:90%;z-index:2000;}"
};
function an(t, e) {
  Xe(e, !0), xr(t, kr);
  const n = Sr(e, "title", 7);
  let r;
  nr(() => {
    if (r) {
      const a = r.getBoundingClientRect();
      a.x < $t ? r.style.left = `calc(50% + ${-(a.x - $t)}px)` : a.x + a.width > window.innerWidth - $t && (r.style.left = `calc(50% - ${a.x + a.width - window.innerWidth + $t}px)`);
    }
  });
  var i = Rr(), s = Yn(i, !0);
  return Un(i), Tr(i, (a) => r = a, () => r), ir(() => br(s, n())), en(t, i), Je({
    get title() {
      return n();
    },
    set title(a) {
      n(a), Be();
    }
  });
}
Or(an, { title: {} }, [], [], !0);
const on = 1e3, Pr = 10, Lr = 1e3;
let Bt = 0, Vt = on, _e;
const Dr = (t, e) => {
  if (window.matchMedia("(any-hover: none)").matches)
    return;
  let n, r;
  e ? t.title = e : e = t.title, e && (t.addEventListener("mouseenter", () => {
    t.title = "", clearTimeout(r), r = setTimeout(() => {
      n || (t.setAttribute("aria-describedby", "mt-rich-text-editor-tooltip"), n = ee(an, {
        target: t,
        props: {
          title: e
        }
      }), Bt++, Vt = Pr);
    }, Vt);
  }), t.addEventListener("mouseleave", () => {
    t.title = e, clearTimeout(r), n && (t.removeAttribute("aria-describedby"), rn(n), n = void 0, Bt--, clearTimeout(_e), _e = setTimeout(() => {
      Bt === 0 && (Vt = on);
    }, Lr));
  }));
};
class jt extends HTMLElement {
  get shadowRoot() {
    return super.shadowRoot;
  }
  editor;
  options = {};
  get tiptap() {
    return this.editor?.tiptap;
  }
  constructor() {
    super(), this.attachShadow({ mode: "open" });
  }
  onEditorInit(e, n) {
    this.editor = e, this.options = n;
  }
  onEditorUpdate() {
  }
}
const Mr = `/* Default color of buttons on iOS is different from others, unify them. */
button:not(:disabled) {
  color: inherit;
}

:host > button {
  width: 34px;
  height: 34px;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 14px;

  & svg {
    width: 24px;
    height: 24px;
  }

  &:not(.is-disabled):hover,
  &.is-active {
    background: #dee0e2;
  }

  &.button-with-text-label {
    width: auto;

    & svg + span {
      padding: 0 0.25rem;
    }
  }
}

:host > button.tooltip-disabled .mt-rich-text-editor-tooltip {
  display: none;
}

:host > button:disabled *:not(.mt-rich-text-editor-tooltip) {
  opacity: 0.5;
  cursor: default;
}
`, ln = document.createElement("style");
ln.textContent = Mr;
class jr extends jt {
  constructor() {
    super(), this.shadowRoot.appendChild(ln.cloneNode(!0));
  }
  connectedCallback() {
    const e = this.shadowRoot.querySelector("button");
    e && Dr(e);
  }
}
class Fr extends jt {
}
const qr = `:host > button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: initial;
  padding: 5px 10px 5px 30px;
  width: 100%;

  & svg {
    width: 12px;
    height: 12px;
  }

  &:not(.is-disabled):hover {
    background: #dee0e2;
  }
}
`, un = document.createElement("style");
un.textContent = qr;
const he = {
  Default: 1,
  High: 2
};
class Hr extends jt {
  static Priority = he;
  content = void 0;
  constructor() {
    super(), this.shadowRoot.appendChild(un.cloneNode(!0));
  }
  isEditorItemAvailable() {
    return Promise.resolve(he.Default);
  }
  onEditorSetPasteContent(e) {
    this.content = e;
  }
  insertContent(e) {
    this.content?.transaction(() => {
      const { tiptap: n, editor: r } = this;
      !n || !r || (n.chain().undo().focus().run(), n.commands.insertContent(
        typeof e == "string" ? r.preprocessHTML(e) : e
      ));
    }), this.parentElement?.dispatchEvent(new Event("paste-menu-item-applied"));
  }
  onEditorPaste() {
    throw new Error("onEditorPaste is not implemented");
  }
}
const Br = `:host > button {
  display: flex;
  align-items: center;
  gap: 10px;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  font-size: inherit;

  .icon:not(svg) {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 4px;
  }
}
`, fn = document.createElement("style");
fn.textContent = Br;
class Vr extends jt {
  aliases;
  variant;
  constructor() {
    super(), this.shadowRoot.appendChild(fn.cloneNode(!0));
  }
  connectedCallback() {
    this.variant = this.dataset.mtRichTextEditorPanelItemVariant;
  }
  insertContent(e) {
    const n = this.tiptap;
    if (!n)
      return;
    const r = n.state.doc.childCount <= 1;
    n.chain().focus().selectParentNode().insertContent(e).run(), r && n.chain().blur().focus("end").run();
  }
}
const ks = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PasteMenuItemElement: Hr,
  QuickActionItemElement: Vr,
  StatusbarItemElement: Fr,
  ToolbarItemElement: jr
}, Symbol.toStringTag, { value: "Module" }));
export {
  ss as $,
  fr as A,
  W as B,
  z as C,
  Gr as D,
  me as E,
  Q as F,
  we as G,
  ve as H,
  it as I,
  pe as J,
  yr as K,
  V as L,
  Qt as M,
  lt as N,
  Qr as O,
  bs as P,
  Ns as Q,
  te as R,
  Nt as S,
  pt as T,
  T as U,
  ds as V,
  Cn as W,
  ts as X,
  Zr as Y,
  be as Z,
  Tn as _,
  or as a,
  Dr as a$,
  mr as a0,
  $s as a1,
  $r as a2,
  Ss as a3,
  Es as a4,
  ws as a5,
  ys as a6,
  Gt as a7,
  Xt as a8,
  yn as a9,
  As as aA,
  en as aB,
  Je as aC,
  H as aD,
  N as aE,
  Be as aF,
  Yn as aG,
  cs as aH,
  Un as aI,
  Cs as aJ,
  fs as aK,
  ms as aL,
  gs as aM,
  xr as aN,
  hs as aO,
  vs as aP,
  ir as aQ,
  ls as aR,
  br as aS,
  Is as aT,
  xs as aU,
  jr as aV,
  ee as aW,
  rn as aX,
  Mr as aY,
  $t as aZ,
  K as a_,
  Jr as aa,
  Kr as ab,
  Xr as ac,
  Qe as ad,
  es as ae,
  ns as af,
  L as ag,
  Y as ah,
  h as ai,
  Mt as aj,
  Ts as ak,
  as as al,
  p as am,
  _s as an,
  nr as ao,
  Ee as ap,
  rs as aq,
  _t as ar,
  cr as as,
  ht as at,
  is as au,
  Or as av,
  Xe as aw,
  Sr as ax,
  wr as ay,
  Tr as az,
  ar as b,
  os as b0,
  Fr as b1,
  qr as b2,
  Hr as b3,
  Vr as b4,
  Os as b5,
  Rs as b6,
  ks as b7,
  Oe as c,
  $n as d,
  us as e,
  gt as f,
  g,
  b as h,
  Z as i,
  E as j,
  Hn as k,
  xn as l,
  v as m,
  Ur as n,
  qn as o,
  ur as p,
  kt as q,
  ps as r,
  U as s,
  Yr as t,
  Se as u,
  Zt as v,
  Wr as w,
  zr as x,
  Ge as y,
  Le as z
};
//# sourceMappingURL=component-DaN8cu97.js.map
